import { useEffect, useState } from 'react';

export default function OfflinePage() {
  const [retrying, setRetrying] = useState(false);

  useEffect(() => {
    const onOnline = () => window.location.reload();
    window.addEventListener('online', onOnline);
    return () => window.removeEventListener('online', onOnline);
  }, []);

  const handleRetry = () => {
    setRetrying(true);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  return (
    <main className="flex h-screen w-full flex-col items-center justify-center bg-background px-6 text-center text-fg">
      <div className="mb-6 text-7xl">🗺️</div>
      <img
        src="/branding/logo-hakkencity-opt.png"
        alt="Hakken City"
        className="mb-8 h-16 w-auto object-contain opacity-60"
      />
      <h1 className="font-display text-3xl font-black text-accent">Sem ligação</h1>
      <p className="mt-3 max-w-xs font-body text-sm text-muted">
        Não foi possível ligar ao servidor. Verifica a tua ligação à internet e tenta novamente.
      </p>
      <button
        onClick={handleRetry}
        disabled={retrying}
        className="mt-8 rounded-2xl bg-ocean px-8 py-3 font-body text-base font-bold text-white shadow-game-card active:scale-95 disabled:opacity-50"
      >
        {retrying ? 'A tentar...' : 'Tentar novamente'}
      </button>
    </main>
  );
}
